import React from 'react'
import {  OkCompFieldModuleAdapterFuncComp } from 'OkApp/modules';

export default function FieldAdapter({ ComponentView, ...props }) {
     
    return <OkCompFieldModuleAdapterFuncComp {...props} {...props.propscomp} >
        {(propsN) => < ComponentView {...propsN} />}
    </OkCompFieldModuleAdapterFuncComp>
}
